module.exports = __webpack_public_path__ + "sg.44bd47a312db4a7a5523.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/sg.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/sg.svg
// module chunks = styles